<template>
  <div>
    <div class="wholePage" v-show="!showDtl">
      <div class="topBar">
        <div class="title">产品类型</div>
        <el-select
          v-model="appType"
          clearable
          @change="getAllAppList"
        >
          <el-option
            v-for="item in appTypeList"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          v-model="keyWords"
          class="search"
          placeholder="请输入"
          clearable
          @clear="getAllAppList"
          @keyup.enter.native="getAllAppList"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="getAllAppList"></i>
        </el-input>

        <div class="btnForPub btnMr" style=margin-left:500px @click="openAddDialog">新增</div>
        <div class="btnForPub btnMr" @click="batchPublishApp">发布</div>
        <div class="btnForPub btnMr" @click="batchCancelPublishApp">取消发布</div>
<!--        <el-input-->
<!--          v-model="keyWords"-->
<!--          class="search"-->
<!--          placeholder="请输入"-->
<!--          clearable-->
<!--          @clear="getAllAppList"-->
<!--          @keyup.enter.native="getAllAppList"-->
<!--        >-->
<!--          <i slot="suffix" class="el-input__icon el-icon-search" @click="getAllAppList"></i>-->
<!--        </el-input>-->
      </div>
      <div class="tableContainer">
        <el-table :data="tableData"
                  @selection-change="handleSelectionChange"
                  style="width: 1600px;margin: auto;"
                  :header-cell-style="{background:'#d3d9e1',color:'#4C545D',fontSize:'18px'}"
                  :cell-style="{fontSize:'14px',color:'#333333'}"
                  stripe
                  border
        >
          <div slot="empty" style="font-size: 18px;text-align: center;color: #333333">
            暂无数据
          </div>
          <el-table-column align="center" type="selection"></el-table-column>
          <el-table-column align="center" label="序号" width="70">
            <template slot-scope="scope">
              <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="产品类型" prop="applyName" width="160"></el-table-column>
          <el-table-column align="center" label="产品型号" prop="applytypeName" width="160"></el-table-column>
          <el-table-column align="center" label="升级包版本" prop="version" width="160"></el-table-column>
          <el-table-column align="center" label="上传时间" prop="updateTime" width="160"></el-table-column>
          <el-table-column align="center" label="使用说明" prop="operatingCarrier" class-name="breakWords"></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div class="opeBtn" style="width: 56px;" @click="changeOnePublishStatus(scope.row)">
                {{ scope.row.applyStatus === 2 ? '取消发布' : '发布' }}
              </div>
<!--              <div class="opeBtn" @click="openPreviewDialog(scope.row)">查看详情</div>-->
              <div class="opeBtn" :style="{cursor: scope.row.applyStatus === 2 ? 'not-allowed' : 'pointer'}" @click="openEditDialog(scope.row)">编辑</div>
              <div class="opeBtn" @click="delApp(scope.row)">删除</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          style="text-align: center; margin-top: 20px; margin-bottom: 10px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 25, 50, 100, 150]"
          :page-size="pageSize"
          layout="total,sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    //新增弹窗
    <el-dialog
      :visible.sync="addOrEditVisible"
      append-to-body
      class="loginDialog"
      width="550px"
      @closed="closeAddOrEditDialog"
      :close-on-click-modal="false"
    >
      <div class="loginDialog__wrap" style="margin-top: -30px;">
        <div class="loginDialog__wrap__title">
          上传升级包
          <i class="el-icon-close" @click="addOrEditVisible = false"></i>
        </div>
        <div class="loginDialog__wrap__content">
          <el-form
            ref="appForm"
            style="text-align: left;"
            label-position="right"
            label-width="120px"
            :model="appDtl"
            :rules="rules"
          >
            <el-form-item
              label="产品类型"
              prop="dvcAgreement"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-select
                filterable
                multiple
                clearable
                style="width: 300px;"
                v-model="appDtl.dvcAgreement"
              >
                <el-option
                  v-for="item in dvcAgreementList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="产品型号"
              prop="dvcAgreement"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-select
                filterable
                multiple
                clearable
                style="width: 300px;"
                v-model="appDtl.dvcAgreement"
              >
                <el-option
                  v-for="item in dvcAgreementList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="升级包版本"
              prop="price"
              :rules="[
            { required: true, message: '不能为空', trigger: ['blur','change'] },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.price"
                :maxlength="$len.input"
                placeholder="请输入"
                @input="priceRegExp($event)"
                @blur="blurCheck()"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="上传升级包"
              prop="appId"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <div>
                <el-upload
                  accept="gmos"
                  action=""
                  :limit=1
                  :file-list="appDtl.appArr"
                  :http-request="uploadAppFile"
                  :before-upload="beforeUpload"
                  :on-remove="handleRemoveFile">
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <el-form-item
              label="校验码"
              prop="price"
              :rules="[
            { required: true, message: '不能为空', trigger: ['blur','change'] },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.price"
                :maxlength="$len.input"
                placeholder="请输入"
                @input="priceRegExp($event)"
                @blur="blurCheck()"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="使用说明" prop="desc">
              <el-input
                type="textarea"
                style="width: 300px;"
                v-model="appDtl.desc"
                :maxlength="$len.area"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <div style="text-align: right;margin-right: 20px">
              <div class="btnForPub btnMr" style="width: 80px;" @click="closeAddOrEditDialog">取消</div>
              <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(0)">保存</div>
              <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(2)">发布</div>
            </div>
          </el-form>
<!--          <div class="login-btn-container">-->
<!--            <div class="login-btn" @click="appendSubmit('find')">确认</div>-->
<!--            <br>-->
<!--            <span class="smallbtn line" @click="findDialogVisible=false">登录</span>-->
<!--          </div>-->
        </div>
      </div>
    </el-dialog>
    //编辑弹窗
    <el-dialog
      :visible.sync="addOrEditVisible"
      append-to-body
      class="loginDialog"
      width="550px"
      @closed="closeAddOrEditDialog"
      :close-on-click-modal="false"
    >
      <div class="loginDialog__wrap" style="margin-top: -30px;">
        <div class="loginDialog__wrap__title">
          编辑升级包
          <i class="el-icon-close" @click="addOrEditVisible = false"></i>
        </div>
        <div class="loginDialog__wrap__content">
          <el-form
            ref="appForm"
            style="text-align: left;"
            label-position="right"
            label-width="120px"
            :model="appDtl"
            :rules="rules"
          >
            <el-form-item
              label="产品类型"
              prop="dvcAgreement"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-select
                filterable
                multiple
                clearable
                style="width: 300px;"
                v-model="appDtl.dvcAgreement"
              >
                <el-option
                  v-for="item in dvcAgreementList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="产品型号"
              prop="dvcAgreement"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-select
                filterable
                multiple
                clearable
                style="width: 300px;"
                v-model="appDtl.dvcAgreement"
              >
                <el-option
                  v-for="item in dvcAgreementList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="升级包版本"
              prop="price"
              :rules="[
            { required: true, message: '不能为空', trigger: ['blur','change'] },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.price"
                :maxlength="$len.input"
                placeholder="请输入"
                @input="priceRegExp($event)"
                @blur="blurCheck()"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="上传升级包"
              prop="appId"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <div>
                <el-upload
                  accept="gmos"
                  action=""
                  :limit=1
                  :file-list="appDtl.appArr"
                  :http-request="uploadAppFile"
                  :before-upload="beforeUpload"
                  :on-remove="handleRemoveFile">
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <el-form-item
              label="校验码"
              prop="price"
              :rules="[
            { required: true, message: '不能为空', trigger: ['blur','change'] },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.price"
                :maxlength="$len.input"
                placeholder="请输入"
                @input="priceRegExp($event)"
                @blur="blurCheck()"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="使用说明" prop="desc">
              <el-input
                type="textarea"
                style="width: 300px;"
                v-model="appDtl.desc"
                :maxlength="$len.area"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <div style="text-align: right;margin-right: 20px">
              <div class="btnForPub btnMr" style="width: 80px;" @click="closeAddOrEditDialog">取消</div>
              <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(0)">保存</div>
              <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(2)">发布</div>
            </div>
          </el-form>
          <!--          <div class="login-btn-container">-->
          <!--            <div class="login-btn" @click="appendSubmit('find')">确认</div>-->
          <!--            <br>-->
          <!--            <span class="smallbtn line" @click="findDialogVisible=false">登录</span>-->
          <!--          </div>-->
        </div>
      </div>
    </el-dialog>
    //查看详情
    <el-dialog
      :visible.sync="addOrEditVisible"
      append-to-body
      class="loginDialog"
      width="550px"
      @closed="closeAddOrEditDialog"
      :close-on-click-modal="false"
    >
      <div class="loginDialog__wrap" style="margin-top: -30px;">
        <div class="loginDialog__wrap__title">
          升级包详情
          <i class="el-icon-close" @click="addOrEditVisible = false"></i>
        </div>
        <div class="loginDialog__wrap__content">
          <el-form
            ref="appForm"
            style="text-align: left;"
            label-position="right"
            label-width="120px"
            :model="appDtl"
            :rules="rules"
          >
            <el-form-item
              label="产品类型"
              prop="dvcAgreement"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-select
                filterable
                multiple
                clearable
                style="width: 300px;"
                v-model="appDtl.dvcAgreement"
              >
                <el-option
                  v-for="item in dvcAgreementList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="产品型号"
              prop="dvcAgreement"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <el-select
                filterable
                multiple
                clearable
                style="width: 300px;"
                v-model="appDtl.dvcAgreement"
              >
                <el-option
                  v-for="item in dvcAgreementList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="升级包版本"
              prop="price"
              :rules="[
            { required: true, message: '不能为空', trigger: ['blur','change'] },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.price"
                :maxlength="$len.input"
                placeholder="请输入"
                @input="priceRegExp($event)"
                @blur="blurCheck()"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="上传升级包"
              prop="appId"
              :rules="[
            { required: true, message: '不能为空', trigger: 'change' },
          ]"
            >
              <div>
                <el-upload
                  accept="gmos"
                  action=""
                  :limit=1
                  :file-list="appDtl.appArr"
                  :http-request="uploadAppFile"
                  :before-upload="beforeUpload"
                  :on-remove="handleRemoveFile">
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <el-form-item
              label="校验码"
              prop="price"
              :rules="[
            { required: true, message: '不能为空', trigger: ['blur','change'] },
          ]"
            >
              <el-input
                style="width: 300px;"
                v-model="appDtl.price"
                :maxlength="$len.input"
                placeholder="请输入"
                @input="priceRegExp($event)"
                @blur="blurCheck()"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="使用说明" prop="desc">
              <el-input
                type="textarea"
                style="width: 300px;"
                v-model="appDtl.desc"
                :maxlength="$len.area"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <div style="text-align: right;margin-right: 20px">
              <div class="btnForPub btnMr" style="width: 80px;" @click="closeAddOrEditDialog">取消</div>
              <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(0)">保存</div>
              <div class="btnForPub btnMr" style="width: 80px;" @click="confirmForm(2)">发布</div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAllGMOSApp } from '../../../api/appStore/allApp'
import { selectApplystypeList, selectDevicetypeList } from '../../../api/appStore/appCommon'
import { mapGetters } from 'vuex'
import { addorEditApp, batchCancelPublish, batchPublish } from '../../../api/appStore/appPublish'

export default {
  name: 'OTAHome',
  watch: {
    'appDtl.appId': {
      handler (newVal, oldVal) {
        // 上传文件的校验需要手动补充触发
        if (this.$refs.appForm) {
          this.$refs.appForm.validateField(['appId'])
        }
      }
    },
    'appDtl.appImg.imageId': {
      handler (newVal, oldVal) {
        // 上传文件的校验需要手动补充触发
        if (this.$refs.appForm) {
          this.$refs.appForm.validateField(['appImg.imageId'])
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getUserName'])
  },
  data () {
    return {
      id: '', // 分类id
      keyWords: '',
      dvcType: '',
      dvcTypeList: [],
      appType: '',
      appTypeList: [],

      appList: [],

      // 表格数据
      tableData: [],
      // 勾选的表格数据项的id组成的数组
      idsArr: [],

      // 分页器相关
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 跟应用软件详情相关的
      showDtl: false,
      // 单个app的详细数据
      appInfo: null,

      // 弹窗相关
      dialogTitle: '', // 弹窗标题
      showUploader: true,
      previewVisible: false, // 查看详情弹窗
      previewApp: {
        // applyName: '',
      }, // 查看详情的APP信息
      addOrEditVisible: false, // 添加or编辑的弹窗
      imgPreviewVisible: false, // 添加or编辑中的预览图片弹窗

      // app细节
      appDtl: {
        id: '',
        // 应用软件封面
        appImg: {
          imageUrl: '',
          imageUrlArr: [
            // {'url':'http://172.16.200.156:8088/apis/api/cafca97472454cd7b7651362832557b5.png'}
          ], // 图片上传组件的绑定值需为list
          imageId: ''
        },
        applyName: '', // 应用软件名称
        price: '', // 价格
        appType: '', // 应用软件类型
        appId: '', // 应用软件，上传文件后返回appId
        appArr: [], // 应用软件文件上传列表
        version: '', // 应用软件版本
        premise: [], // 运行环境
        dvcType: [], // 支持设备类型
        dvcMaster: '', // 支持设备厂家
        dvcAgreement: [], // 支持设备协议
        desc: ''// 功能描述
      }
    }
  },
  methods: {
    // 进入详情页
    // gotoAppDetails(item) {
    //   this.appInfo = item;
    //   this.showDtl = true;
    // },
    // 返回首页
    returnToAppHome () {
      this.appInfo = null
      this.showDtl = false
    },
    // 切换分页
    handleCurrentChange (val) {
      this.currentPage = val
      this.getAllAppList()
    },
    // 切换单页大小
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getAllAppList()
    },
    // 从路由中获取参数
    getPageDtl (params) {
      this.id = params.id
    },
    // 获取支持设备类型列表
    getDvcTypeList () {
      selectDevicetypeList().then(res => {
        if (res.returnCode === '100') {
          let dataArr = res.returnData
          let resArr = []
          for (let i = 0; i < dataArr.length; i++) {
            let item = {
              label: dataArr[i].devicetypeName,
              value: dataArr[i].id + ''
            }
            resArr.push(item)
          };
          this.dvcTypeList = resArr
        }
      }).catch(e => e)
    },
    // 获取分类应用软件分页列表
    async getAllAppList () {
      this.showLoading1 = true
      await getAllGMOSApp({
        applyName: this.keyWords,
        applytypeId: this.appType,
        deviceTypeId: this.dvcType,
        curPage: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res.returnCode === '1000') { // 该接口还需给GMOS用，因此特殊采用1000的returnCode
          this.appList = res.returnData.applys
          this.total = res.returnData.count ? res.returnData.count : 0
        } else {
          this.$msg(res.returnMsg)
        }
      }).catch(e => e)
      this.showLoading1 = false
    },
    // 获取全部分类
    getAppTypeList () {
      selectApplystypeList().then(res => {
        if (res.returnCode === '100') {
          let dataArr = res.returnData
          let resArr = []
          for (let i = 0; i < dataArr.length; i++) {
            let item = {
              label: dataArr[i].applytypeName,
              value: dataArr[i].applytypeId
            }
            resArr.push(item)
          };
          this.appTypeList = resArr
        }
      }).catch(e => e)
    },
    openAddDialog () {
      if (this.$refs.appForm) {
        this.$refs.appForm.clearValidate()
      }
      this.dialogTitle = '上传固件'
      this.appDtl.id = ''
      this.addOrEditVisible = true
    },
    // 关闭新增或编辑弹窗
    closeAddOrEditDialog () {
      if (this.$refs.appForm) {
        this.$refs.appForm.resetFields()
        // this.resetAppDtl();
      }
      this.appDtl.appImg.imageUrlArr = [] // 清空图片列表
      this.appDtl.appArr = [] // 清空上传文件的列表
      this.addOrEditVisible = false
    },
    // 批量发布
    batchPublishApp () {
      if (this.idsArr.length === 0) {
        this.$msg('请勾选固件', 'warning')
        return
      }
      batchPublish(this.idsArr.toString()).then(res => {
        this.$msg('批量发布成功', 'success')
        this.searchData()
      }).catch(e => e)
    },
    // 批量取消发布
    batchCancelPublishApp () {
      if (this.idsArr.length === 0) {
        this.$msg('请勾选固件', 'warning')
        return
      }
      batchCancelPublish(this.idsArr.toString()).then(res => {
        this.$msg('批量取消发布成功', 'success')
        this.searchData()
      }).catch(e => e)
    },
    // 弹窗的提交事件
    confirmForm (applyStatus) { // 0是保存，2是发布
      this.$refs.appForm.validate((valid) => {
        if (valid) {
          if (!this.appDtl.id) { // 添加的情况
            addorEditApp({
              createBy: this.getUserName,
              imsId: this.appDtl.appImg.imageId, // 应用软件封面
              applyName: this.appDtl.applyName, // 应用软件名称
              price: this.appDtl.price, // 价格
              applytypeId: this.appDtl.appType, // 应用软件类型
              appId: this.appDtl.appId, // 应用软件导入
              version: this.appDtl.version, // 应用软件版本
              operatingCarrier: this.appDtl.premise.toString(), // 运行环境
              deviceTypes: this.appDtl.dvcType.toString(), // 支持设备类型
              deviceManufacturers: this.appDtl.dvcMaster, // 支持设备厂家
              deviceProtocols: this.appDtl.dvcAgreement.toString(), // 支持设备协议
              applyDescription: this.appDtl.desc, // 功能描述
              applyStatus: applyStatus // 应用软件状态
            }).then(res => {
              if (res.returnCode === '100') {
                this.$msg('新增成功', 'success')
                this.closeAddOrEditDialog()
                this.searchData()
              } else {
                this.$msg(res.returnMsg)
              }
            }).catch(e => e)
          } else if (this.appDtl.id) { // 编辑的情况
            addorEditApp({
              createBy: this.getUserName,
              id: this.appDtl.id, // GMOS APPid，编辑才会带出
              imsId: this.appDtl.appImg.imageId, // GMOS APP封面
              applyName: this.appDtl.applyName, // GMOS APP名称
              price: this.appDtl.price, // 价格
              applytypeId: this.appDtl.appType, // GMOS APP类型
              appId: this.appDtl.appId, // GMOS APP导入
              version: this.appDtl.version, // GMOS APP版本
              operatingCarrier: this.appDtl.premise.toString(), // 运行环境
              deviceTypes: this.appDtl.dvcType.toString(), // 支持设备类型
              deviceManufacturers: this.appDtl.dvcMaster, // 支持设备厂家
              deviceProtocols: this.appDtl.dvcAgreement.toString(), // 支持设备协议
              applyDescription: this.appDtl.desc, // 功能描述
              applyStatus: applyStatus, // GMOS APP状态
              applyNameChange: this.checkKeyChange() // 判断是否重名的参数
            }).then(res => {
              if (res.returnCode === '100') {
                this.$msg('编辑成功', 'success')
                this.closeAddOrEditDialog()
                this.searchData()
              } else {
                this.$msg(res.returnMsg)
              }
            }).catch(e => e)
          }
        }
      })
    },
    initPageData () {
      this.getAppTypeList()
      this.getDvcTypeList()
      this.getAllAppList()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getPageDtl(to.params)
      vm.initPageData()
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.getPageDtl(to.params)
    this.initPageData()
    next()
  }
}
</script>

<style scoped lang="less">
  .wholePage {
    font-size: 18px;
    text-align: left;
    min-height: 100vh;
    background-color: white;
    border: 2px solid #f0f0f0;
    border-radius: 5px;
    padding-top: 10px;
    padding-left: 10px;
  }

  .topBar {
    margin-bottom: 20px;
    .search {
      width: 200px;
      margin-left: 20px;
      i {
        cursor: pointer;
      }
    }

    .title {
      display: inline-block;
      font-size: 18px;
      margin: 0 10px 0 20px;
    }
  }

  /*弹窗样式*/
  .dialogTitle {
    font-size: 18px;
    color: #224E7F;
    text-align: left;
    font-weight: bold;
    border-bottom: 1px solid #EEEEEE;
  }
  /*按钮样式*/
  .btnForPub {
    background-color: #5c89e5;
    color: #FFFFFF;
    font-size: 16px;
    height: 40px;
    width: 120px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
  }
  .btnMr {
    /*margin-right: 20px;*/
    margin-left: 20px;
  }
  .noData {
    text-align: center;
    padding-top: 40vh;
  }
  .loginDialog__wrap {
    box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.2);
    border-right: 4px;
    background-color: transparent;

    &__title {
      position: relative;
      text-align: left;
      font-size: 20px;
      background-color: #5c89e5;
      color: #ffffff;
      font-weight: bold;
      padding: 12px 36px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;

      .el-icon-close {
        position: absolute;
        right: 8px;
        top: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;
        font-size: 28px;
        height: 28px;
      }
    }

    &__content {
      padding: 37px 36px 10px 36px;
      background-color: #fff;

      .smallbtn {
        font-size: 13px;
        color: #5c89e5;
        padding-top: 2px;
        display: inline-block;
        cursor: pointer;

        &.line {
          border-bottom: 2px solid;
          /*padding-bottom: 2px;*/
        }
      }

      .login-btn-container {
        text-align: center;
        margin: 12px auto;
      }

      .login-btn {
        display: inline-block;
        background-color: #5c89e5;
        border-radius: 6px;
        padding: 6px 24px;
        color: #ffffff;
        font-size: 17px;
        cursor: pointer;

      }
    }
  }
</style>
